import { Markierung } from '@/gql/graphql';
import { t } from 'i18next';

export class Termin {
  constructor(
    readonly titel?: string,
    readonly wiederholung?: TerminWiederholung,
    readonly id?: string,
    readonly bildUrl?: string,
    readonly bildName?: string,
    readonly beschreibung?: string,
    readonly beginn?: Date,
    readonly ende?: Date,
    readonly markierung?: Markierung,
  ) {}
}

export enum TerminWiederholung {
  JAEHRLICH = 'JAEHRLICH',
  MONATLICH = 'MONATLICH',
  WOECHENTLICH = 'WOECHENTLICH',
  TAEGLICH = 'TAEGLICH',
  OHNE = 'OHNE',
}

export function getWiederholungStringFromTerminWiederholung(
  wiederholung: TerminWiederholung,
) {
  switch (wiederholung) {
    case TerminWiederholung.JAEHRLICH:
      return t('entities.wiederholung.jaehrlich');
    case TerminWiederholung.MONATLICH:
      return t('entities.wiederholung.monatlich');
    case TerminWiederholung.WOECHENTLICH:
      return t('entities.wiederholung.woechentlich');
    case TerminWiederholung.TAEGLICH:
      return t('entities.wiederholung.taeglich');
    case TerminWiederholung.OHNE:
      return t('entities.wiederholung.einmalig');
  }
}
